module.exports = __webpack_public_path__ + "img/shy.a3f52653.svg";